const Blank = () => {
  console.log('blank displayed ' + window.location.href);
  return <></>;
};

export default Blank;
